export type { EstablishmentFieldRequestItem, EstablishmentFieldRequestsListResponse } from "@/services/establishment-field-request.service";

import { TipoOperacionSolicitudEstablecimiento } from "@/constants/enums";

export const TIPO_CAMPO_LABELS: Record<number, string> = { 1: "Propio", 2: "Alquilado" };

export const OPERACION_LABEL: Record<number, string> = {
  [TipoOperacionSolicitudEstablecimiento.Alta]: "alta",
  [TipoOperacionSolicitudEstablecimiento.Modificacion]: "modificación",
  [TipoOperacionSolicitudEstablecimiento.Baja]: "baja",
};
